var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackArrowIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow_black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#303030",
    transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) ",
    points: "9.53986844 5.85 8.30322477 7.08664367 13.2103321 11.9996711 8.30322477 16.9133563 9.53986844 18.15 15.6967752 11.9996711"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowIc);
export default __webpack_public_path__ + "static/media/black_arrow_ic.ae7a030d7360561776a156f6be6e1583.svg";
export { ForwardRef as ReactComponent };